import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import EmbeddedTypeGroupBoxViewModelType from '@/ViewModels/Controls/EmbeddedTypeGroupBoxViewModel';
import ControlFactory from '@/Factories/ControlFactory';
import ControlFactoryTuple from '@/Factories/ControlFactoryTuple';
import Factory from '@/Factories/Factory';
import LayoutRenderer from '@/Utility/LayoutRenderer';
import * as CoreFrameDTOs from "coreframetypings/dto";

export default class EmbeddedTypeGroupBox extends Control {

    private jQueryControl: JQuery;
    private content: JQuery;

    public constructor(private viewModel: EmbeddedTypeGroupBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');
        this.content = $('<div class="c-content">').appendTo(this.jQueryControl);

        this.applyBindings(this.jQueryControl, {
            controlName: 'embeddedtypegroupbox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible
        });

        this.createItemsAsync(this.viewModel.children, this.createChildAsync).then(items => {
            if (this.isDisposed || this.viewModel.context?.isDisposed !== false)
                return;

            const tuples = items.map(i => i.tuple).filter(t => t != null);
            const $layout = this.createLayout(tuples);
            this.content.append($layout);
            this.widget(null);
        });

        return this.jQueryControl;
    }

    private async createChildAsync(child: CoreFrameDTOs.IDVGItemDTO) {
        return ControlFactory.createInstanceAsync(child, this.viewModel.context, {
            isSummaryViewMode: this.viewModel.isSummaryViewMode,
            locator: this.viewModel.locator,
            isDisplayed: this.viewModel.isDisplayed
        });
    }

    private createLayout(tuples: ControlFactoryTuple[]) {
        return LayoutRenderer.renderLayout(this.viewModel.layout, tuples, this.viewModel.context.labelColumnWidth);
    }
}

ComponentManager.setControl('EmbeddedTypeGroupBox', EmbeddedTypeGroupBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');